module.exports = __webpack_public_path__ + "static/media/header.54689d50.png";